import { render, staticRenderFns } from "./tuzhuangliangting.vue?vue&type=template&id=15d486bc&scoped=true&"
import script from "./tuzhuangliangting.vue?vue&type=script&lang=js&"
export * from "./tuzhuangliangting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d486bc",
  null
  
)

export default component.exports